import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { useState, useEffect, useContext } from "react";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import logo from "../../Images/hlogo.png";
import Slide from "@mui/material/Slide";
import "./SideBar.css";
// import '../../Common.css'
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import Avatar from "@mui/material/Avatar";
// import btnprf from '../../../Images/btnprf.png'
// import { useTheme } from '@mui/material/styles';
import useMediaQuery from "@mui/material/useMediaQuery";
import Drawer from "@mui/material/Drawer";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import LogoutIcon from "@mui/icons-material/Logout";
import Darkmode from "../DarkMode/Darkmode";
import { ThemeContext } from "../DarkMode/ThemeProvider";
import ExpandMore from "@mui/icons-material/ExpandMore";
import profile from "../../Images/profile-img.png";
import { Link, useNavigate } from "react-router-dom";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import HistoryIcon from "@mui/icons-material/History";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Collapse from "@mui/material/Collapse";
import Modal from "@mui/material/Modal";
import { Grid2 } from "@mui/material";
import Grid from "@mui/material/Grid2";
import upload from "../../Images/upload.svg";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import "../EditProfile/EditProfile.css";
import TextField from "@mui/material/TextField";
import { ToastContainer, toast } from "react-toastify";
import GroupIcon from "@mui/icons-material/Group";
import CampaignIcon from "@mui/icons-material/Campaign";
import AppsIcon from "@mui/icons-material/Apps";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import DescriptionIcon from "@mui/icons-material/Description";
import profile1 from "../../Images/profile-avatar.png";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { useAuth } from "../../context/AuthContext";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { getUserDetails, updateOneUser } from "../../services/User";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const settings = [
  {
    icon: (
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.16797 0.167969C7.0629 0.167969 6.00309 0.606956 5.22169 1.38836C4.44029 2.16976 4.0013 3.22957 4.0013 4.33464C4.0013 5.4397 4.44029 6.49951 5.22169 7.28091C6.00309 8.06232 7.0629 8.5013 8.16797 8.5013C9.27304 8.5013 10.3328 8.06232 11.1142 7.28091C11.8956 6.49951 12.3346 5.4397 12.3346 4.33464C12.3346 3.22957 11.8956 2.16976 11.1142 1.38836C10.3328 0.606956 9.27304 0.167969 8.16797 0.167969ZM8.16797 9.33463C8.66075 9.33575 9.13964 9.36908 9.60464 9.43464C9.76101 9.45649 9.90796 9.52231 10.0284 9.62445C10.1488 9.72659 10.2377 9.86083 10.2848 10.0115C10.3318 10.1623 10.3351 10.3232 10.2942 10.4758C10.2533 10.6283 10.17 10.766 10.0538 10.873C9.36796 11.5013 8.84278 12.2849 8.52234 13.158C8.20189 14.0312 8.09552 14.9685 8.21214 15.8913C8.22686 16.0099 8.2159 16.1302 8.18003 16.2442C8.14415 16.3582 8.08419 16.4631 8.00421 16.5518C7.92422 16.6406 7.82609 16.7111 7.71645 16.7586C7.60682 16.8061 7.48826 16.8295 7.3688 16.8271C5.6938 16.7938 4.12714 16.6471 2.95714 16.2888C2.37214 16.1096 1.82047 15.858 1.40214 15.4871C0.959635 15.0955 0.667969 14.568 0.667969 13.918C0.667969 13.2621 0.966302 12.6488 1.3713 12.1355C1.78297 11.6146 2.35214 11.1355 3.01964 10.7271C4.35547 9.9138 6.17214 9.33463 8.16797 9.33463ZM16.678 10.1963C17.0685 10.587 17.2879 11.1168 17.2879 11.6692C17.2879 12.2216 17.0685 12.7515 16.678 13.1421L13.8296 15.9905C13.6385 16.1815 13.3905 16.3055 13.123 16.3438L11.1988 16.6188C11.0706 16.6372 10.9398 16.6255 10.8169 16.5846C10.694 16.5436 10.5823 16.4746 10.4907 16.3829C10.3991 16.2913 10.3302 16.1796 10.2894 16.0566C10.2485 15.9336 10.2369 15.8029 10.2555 15.6746L10.5305 13.7513C10.5686 13.4834 10.6926 13.2352 10.8838 13.0438L13.7321 10.1955C14.1228 9.8049 14.6526 9.5855 15.2051 9.5855C15.7575 9.5855 16.2873 9.8049 16.678 10.1955L16.678 10.1963Z"
          fill="#575757"
        />
      </svg>
    ),
    name: "Edit Profile",
    click: "open",
  },
  {
    icon: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.97565 3.20898L10.6923 3.20898C11.1382 3.20898 11.509 3.20898 11.8132 3.23398C12.1298 3.25898 12.4265 3.31565 12.7073 3.45898C13.1386 3.67871 13.4893 4.02936 13.709 4.46065C13.8523 4.74148 13.909 5.03815 13.934 5.35482C13.959 5.65898 13.959 6.02982 13.959 6.47565L13.959 9.04232C13.959 9.20808 13.8931 9.36705 13.7759 9.48426C13.6587 9.60147 13.4997 9.66732 13.334 9.66732C13.1682 9.66732 13.0093 9.60147 12.892 9.48426C12.7748 9.36705 12.709 9.20808 12.709 9.04232L12.709 6.50065C12.709 6.02398 12.709 5.70315 12.6882 5.45648C12.669 5.21732 12.634 5.10315 12.5957 5.02815C12.4959 4.83196 12.3367 4.67238 12.1407 4.57232C12.0648 4.53398 11.9507 4.49898 11.7115 4.47982C11.4648 4.45982 11.1448 4.45898 10.6673 4.45898L6.00065 4.45898C5.52398 4.45898 5.20315 4.45898 4.95648 4.47982C4.71732 4.49898 4.60315 4.53398 4.52815 4.57232C4.33183 4.67224 4.17224 4.83183 4.07232 5.02815C4.03398 5.10315 3.99898 5.21732 3.97982 5.45648C3.95982 5.70315 3.95898 6.02315 3.95898 6.50065L3.95898 14.5007C3.95898 14.9773 3.95898 15.2982 3.97982 15.544C3.99898 15.784 4.03398 15.8982 4.07232 15.9732C4.16732 16.159 4.31398 16.3115 4.49565 16.4115C4.50898 16.4148 4.53843 16.4201 4.58398 16.4273C4.68121 16.4418 4.81343 16.4551 4.98065 16.4673C5.31232 16.4923 5.73898 16.509 6.19232 16.5198C7.09648 16.5423 8.07565 16.5423 8.54232 16.5423C8.70808 16.5423 8.86705 16.6082 8.98426 16.7254C9.10147 16.8426 9.16732 17.0016 9.16732 17.1673C9.16732 17.3331 9.10147 17.492 8.98426 17.6093C8.86705 17.7265 8.70808 17.7923 8.54232 17.7923L8.54065 17.7923C8.07398 17.7923 7.08232 17.7923 6.16148 17.7698C5.73694 17.761 5.31266 17.7424 4.88898 17.714C4.72593 17.7033 4.56332 17.6866 4.40148 17.664C4.2489 17.6463 4.09994 17.6052 3.95982 17.5423C3.52909 17.3229 3.17878 16.9729 2.95898 16.5423C2.81565 16.2607 2.75898 15.964 2.73398 15.6473C2.70898 15.3432 2.70898 14.9723 2.70898 14.5265L2.70898 6.47565C2.70898 6.02982 2.70898 5.65898 2.73398 5.35482C2.75898 5.03815 2.81565 4.74148 2.95898 4.46065C3.17871 4.02936 3.52936 3.67871 3.96065 3.45898C4.24148 3.31565 4.53815 3.25898 4.85482 3.23398C5.15898 3.20898 5.52982 3.20898 5.97565 3.20898Z"
          fill="#575757"
        />
        <path
          d="M11.9752 10.709L15.5235 10.709C15.8527 10.709 16.1368 10.709 16.371 10.7282C16.6185 10.7482 16.8643 10.7932 17.1002 10.9132C17.4535 11.0932 17.7402 11.3798 17.9202 11.7332C18.0402 11.969 18.0852 12.2148 18.1052 12.4623C18.1243 12.6957 18.1243 12.9807 18.1243 13.3098L18.1243 15.1915C18.1243 15.5207 18.1243 15.8048 18.1052 16.039C18.0923 16.2919 18.0294 16.5397 17.9202 16.7682C17.7406 17.1211 17.4538 17.4082 17.101 17.5882C16.8643 17.7082 16.6177 17.7532 16.371 17.7732C16.1377 17.7923 15.8527 17.7923 15.5235 17.7923L11.9743 17.7923C11.6452 17.7923 11.361 17.7923 11.1268 17.7732C10.874 17.7603 10.6261 17.6974 10.3977 17.5882C10.0447 17.4086 9.75764 17.1218 9.57768 16.769C9.46835 16.5403 9.40547 16.2922 9.39268 16.039C9.37352 15.8057 9.37351 15.5207 9.37351 15.1915L9.37352 13.309C9.37352 12.9798 9.37352 12.6957 9.39268 12.4615C9.40558 12.2086 9.46845 11.9608 9.57768 11.7323C9.7575 11.3792 10.0446 11.0921 10.3977 10.9123C10.6261 10.8031 10.874 10.7402 11.1268 10.7273C11.3602 10.7082 11.6452 10.7082 11.9743 10.7082M11.2285 11.9732C11.0585 11.9873 10.9952 12.0107 10.9643 12.0265C10.8471 12.0863 10.7517 12.1817 10.6918 12.299C10.6752 12.3307 10.6527 12.3932 10.6385 12.5632L10.6368 12.5832L16.8602 12.5832L16.8585 12.5632C16.8443 12.3932 16.821 12.3298 16.8052 12.299C16.7451 12.1816 16.6494 12.0862 16.5318 12.0265C16.501 12.0098 16.4385 11.9873 16.2685 11.9732C16.0121 11.959 15.7553 11.954 15.4985 11.9582L11.9985 11.9582C11.6385 11.9582 11.4052 11.9582 11.2285 11.9732ZM16.8743 14.2507L10.6243 14.2507L10.6243 15.1673C10.6243 15.5273 10.6243 15.7607 10.6393 15.9373C10.6535 16.1073 10.6768 16.1707 10.6927 16.2007C10.7524 16.3182 10.8478 16.4139 10.9652 16.474C10.9968 16.4907 11.0593 16.5132 11.2293 16.5273C11.406 16.5415 11.6393 16.5423 11.9993 16.5423L15.4993 16.5423C15.8593 16.5423 16.0927 16.5423 16.2693 16.5273C16.4393 16.5132 16.5027 16.4898 16.5327 16.474C16.6504 16.414 16.7461 16.3184 16.806 16.2007C16.8227 16.1698 16.8452 16.1073 16.8593 15.9373C16.8735 15.7607 16.8743 15.5273 16.8743 15.1673L16.8743 14.2507ZM5.41602 5.70898C5.25026 5.70898 5.09128 5.77483 4.97407 5.89204C4.85686 6.00925 4.79102 6.16822 4.79102 6.33398C4.79102 6.49974 4.85686 6.65872 4.97407 6.77593C5.09128 6.89314 5.25026 6.95898 5.41602 6.95898L8.74935 6.95898C8.91511 6.95898 9.07408 6.89314 9.19129 6.77593C9.3085 6.65872 9.37435 6.49974 9.37435 6.33398C9.37435 6.16822 9.3085 6.00925 9.19129 5.89204C9.07408 5.77483 8.91511 5.70898 8.74935 5.70898L5.41602 5.70898ZM4.79102 8.83398C4.79102 8.66822 4.85686 8.50925 4.97407 8.39204C5.09128 8.27483 5.25026 8.20898 5.41602 8.20898L11.2493 8.20898C11.4151 8.20898 11.5741 8.27483 11.6913 8.39204C11.8085 8.50925 11.8743 8.66822 11.8743 8.83398C11.8743 8.99974 11.8085 9.15872 11.6913 9.27593C11.5741 9.39314 11.4151 9.45898 11.2493 9.45898L5.41602 9.45898C5.25026 9.45898 5.09128 9.39314 4.97407 9.27593C4.85686 9.15872 4.79102 8.99974 4.79102 8.83398ZM5.41602 10.709C5.25026 10.709 5.09128 10.7748 4.97407 10.892C4.85686 11.0093 4.79102 11.1682 4.79102 11.334C4.79102 11.4997 4.85686 11.6587 4.97407 11.7759C5.09128 11.8931 5.25026 11.959 5.41602 11.959L8.33268 11.959C8.49844 11.959 8.65741 11.8931 8.77462 11.7759C8.89183 11.6587 8.95768 11.4997 8.95768 11.334C8.95768 11.1682 8.89183 11.0093 8.77462 10.892C8.65741 10.7748 8.49844 10.709 8.33268 10.709L5.41602 10.709ZM4.79102 14.6673C4.79102 14.5016 4.85686 14.3426 4.97407 14.2254C5.09128 14.1082 5.25026 14.0423 5.41602 14.0423L7.08268 14.0423C7.24844 14.0423 7.40741 14.1082 7.52462 14.2254C7.64183 14.3426 7.70768 14.5016 7.70768 14.6673C7.70768 14.8331 7.64183 14.992 7.52462 15.1093C7.40741 15.2265 7.24844 15.2923 7.08268 15.2923L5.41602 15.2923C5.25026 15.2923 5.09128 15.2265 4.97407 15.1093C4.85686 14.992 4.79102 14.8331 4.79102 14.6673Z"
          fill="#575757"
        />
      </svg>
    ),
    name: "Billing",
    url: "/billing",
    click: "",
  },
  // {
  //   icon: (
  //     <svg
  //       width="20"
  //       height="21"
  //       viewBox="0 0 20 21"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         fill-rule="evenodd"
  //         clip-rule="evenodd"
  //         d="M13.4467 4.43955L14.9717 5.96455C17.2126 8.20622 18.3326 9.32622 18.3326 10.7179C18.3326 12.1104 17.2126 13.2304 14.9717 15.4712C12.7301 17.7129 11.6101 18.8329 10.2176 18.8329C8.8259 18.8329 7.70507 17.7129 5.46424 15.4721L3.93924 13.9471C2.65174 12.6587 2.00757 12.0154 1.7684 11.1796C1.5284 10.3437 1.7334 9.45622 2.1434 7.68205L2.37924 6.65872C2.7234 5.16539 2.8959 4.41872 3.40674 3.90705C3.91757 3.39539 4.66507 3.22372 6.1584 2.87955L7.18174 2.64289C8.95674 2.23372 9.8434 2.02872 10.6792 2.26789C11.5151 2.50789 12.1592 3.15205 13.4467 4.43955ZM9.28757 12.4396C8.72674 11.8796 8.7309 11.0746 9.06674 10.4371C8.9836 10.317 8.94514 10.1716 8.95805 10.0261C8.97095 9.88057 9.03441 9.7442 9.13739 9.64062C9.24037 9.53704 9.37638 9.47281 9.52179 9.45906C9.66721 9.44532 9.81284 9.48294 9.9334 9.56539C10.2167 9.41539 10.5276 9.33539 10.8376 9.33872C11.0033 9.34027 11.1617 9.4076 11.2778 9.5259C11.3939 9.64421 11.4583 9.80379 11.4567 9.96955C11.4552 10.1353 11.3879 10.2937 11.2696 10.4098C11.1513 10.5259 10.9917 10.5903 10.8259 10.5887C10.6329 10.5959 10.4506 10.6788 10.3184 10.8196C9.9959 11.1421 10.0801 11.4654 10.1709 11.5562C10.2626 11.6471 10.5851 11.7312 10.9076 11.4087C11.5609 10.7554 12.6892 10.5387 13.4117 11.2612C13.9726 11.8221 13.9684 12.6271 13.6326 13.2646C13.7152 13.3847 13.7532 13.5299 13.7401 13.6751C13.7269 13.8203 13.6635 13.9563 13.5606 14.0596C13.4578 14.163 13.3221 14.2271 13.1769 14.2409C13.0318 14.2548 12.8864 14.2174 12.7659 14.1354C12.392 14.3406 11.9582 14.4089 11.5392 14.3287C11.3768 14.2953 11.2343 14.1988 11.143 14.0603C11.0517 13.9219 11.0192 13.7528 11.0526 13.5904C11.0859 13.4279 11.1825 13.2854 11.3209 13.1941C11.4594 13.1029 11.6285 13.0703 11.7909 13.1037C11.9384 13.1346 12.1767 13.0862 12.3809 12.8821C12.7034 12.5587 12.6192 12.2362 12.5284 12.1454C12.4367 12.0546 12.1142 11.9704 11.7917 12.2929C11.1384 12.9462 10.0101 13.1629 9.28757 12.4396ZM8.34924 9.07705C8.50398 8.92226 8.62671 8.7385 8.71044 8.53627C8.79416 8.33404 8.83724 8.1173 8.8372 7.89843C8.83716 7.67955 8.79401 7.46283 8.71021 7.26063C8.62642 7.05843 8.50362 6.87471 8.34882 6.71997C8.19402 6.56523 8.01027 6.44249 7.80804 6.35877C7.60581 6.27504 7.38907 6.23197 7.17019 6.23201C6.95132 6.23205 6.73459 6.2752 6.53239 6.35899C6.33019 6.44279 6.14648 6.56559 5.99174 6.72039C5.67922 7.03301 5.5037 7.45698 5.50378 7.89902C5.50386 8.34105 5.67953 8.76496 5.99215 9.07747C6.30478 9.38998 6.72874 9.56551 7.17078 9.56543C7.61282 9.56535 8.03672 9.38968 8.34924 9.07705Z"
  //         fill="#575757"
  //       />
  //     </svg>
  //   ),

  //   name: "Pricing",
  //   url: "/pricing",
  //   click: "",
  // },
  // {
  //   icon: (
  //     <svg
  //       width="20"
  //       height="21"
  //       viewBox="0 0 20 21"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         fill-rule="evenodd"
  //         clip-rule="evenodd"
  //         d="M15.0007 2.16602C15.4427 2.16602 15.8666 2.34161 16.1792 2.65417C16.4917 2.96673 16.6673 3.39066 16.6673 3.83268L16.6673 12.166L11.2507 12.166C10.9191 12.166 10.6012 12.2977 10.3668 12.5321C10.1323 12.7666 10.0007 13.0845 10.0007 13.416L10.0007 18.8327L5.00065 18.8327C4.55862 18.8327 4.1347 18.6571 3.82214 18.3445C3.50958 18.032 3.33398 17.608 3.33398 17.166L3.33398 3.83268C3.33398 3.39065 3.50958 2.96673 3.82214 2.65417C4.1347 2.34161 4.55862 2.16602 5.00065 2.16602L15.0007 2.16602ZM16.6315 13.8327C16.5645 14.1484 16.4073 14.4379 16.179 14.666L12.5007 18.3443C12.2725 18.5727 11.983 18.7299 11.6673 18.7968L11.6673 13.8327L16.6315 13.8327ZM8.33398 9.66602L7.50065 9.66602C7.27964 9.66602 7.06768 9.75381 6.9114 9.91009C6.75512 10.0664 6.66732 10.2783 6.66732 10.4993C6.66732 10.7204 6.75512 10.9323 6.9114 11.0886C7.06768 11.2449 7.27964 11.3327 7.50065 11.3327L8.33398 11.3327C8.555 11.3327 8.76696 11.2449 8.92324 11.0886C9.07952 10.9323 9.16732 10.7204 9.16732 10.4993C9.16732 10.2783 9.07952 10.0664 8.92324 9.91009C8.76696 9.75381 8.555 9.66602 8.33398 9.66602ZM12.5007 6.33268L7.50065 6.33268C7.27964 6.33268 7.06768 6.42048 6.9114 6.57676C6.75512 6.73304 6.66732 6.945 6.66732 7.16602C6.66732 7.38703 6.75512 7.59899 6.9114 7.75527C7.06768 7.91155 7.27964 7.99935 7.50065 7.99935L12.5007 7.99935C12.7217 7.99935 12.9336 7.91155 13.0899 7.75527C13.2462 7.59899 13.334 7.38703 13.334 7.16602C13.334 6.945 13.2462 6.73304 13.0899 6.57676C12.9336 6.42048 12.7217 6.33268 12.5007 6.33268Z"
  //         fill="#575757"
  //       />
  //     </svg>
  //   ),
  //   name: "Documentation",
  //   url: "",
  //   click: "",
  // },
  // {
  //   icon: (
  //     <svg
  //       width="20"
  //       height="21"
  //       viewBox="0 0 20 21"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M16.7818 6.5L19.5644 9.28261L18.347 10.5L15.5644 7.71739C15.26 7.89131 14.9339 8.03624 14.5861 8.15218C14.2383 8.26812 13.8687 8.32609 13.4774 8.32609C12.3905 8.32609 11.4667 7.9458 10.7061 7.18522C9.94553 6.42464 9.56495 5.50058 9.56437 4.41305C9.56379 3.32551 9.94437 2.40174 10.7061 1.64174C11.4678 0.881742 12.3916 0.501162 13.4774 0.500003C14.5632 0.498843 15.4873 0.879423 16.2496 1.64174C17.0119 2.40406 17.3922 3.32783 17.3905 4.41305C17.3905 4.80435 17.3325 5.17392 17.2165 5.52174C17.1006 5.86957 16.9557 6.19565 16.7818 6.5ZM13.4774 6.58696C14.0861 6.58696 14.6006 6.37681 15.0209 5.95652C15.4412 5.53623 15.6513 5.02174 15.6513 4.41305C15.6513 3.80435 15.4412 3.28986 15.0209 2.86957C14.6006 2.44928 14.0861 2.23913 13.4774 2.23913C12.8687 2.23913 12.3542 2.44928 11.9339 2.86957C11.5136 3.28986 11.3035 3.80435 11.3035 4.41305C11.3035 5.02174 11.5136 5.53623 11.9339 5.95652C12.3542 6.37681 12.8687 6.58696 13.4774 6.58696ZM3.47741 17.8913C2.99915 17.8913 2.58988 17.7212 2.24959 17.3809C1.9093 17.0406 1.73886 16.631 1.73828 16.1522L1.73828 3.97826C1.73828 3.5 1.90872 3.09073 2.24959 2.75044C2.59046 2.41015 2.99973 2.23971 3.47741 2.23913L8.26002 2.23913C8.1006 2.60145 7.9919 2.97479 7.93393 3.35913C7.87596 3.74348 7.84698 4.12377 7.84698 4.5C7.84698 6.07971 8.40495 7.39855 9.52089 8.45652C10.6368 9.5145 11.9629 10.0435 13.4992 10.0435C13.7745 10.0435 14.0499 10.0252 14.3252 9.9887C14.6006 9.95218 14.8832 9.89073 15.1731 9.80435L17.3905 12.0217L17.3905 16.1522C17.3905 16.6304 17.2203 17.04 16.88 17.3809C16.5397 17.7217 16.1302 17.8919 15.6513 17.8913L3.47741 17.8913Z"
  //         fill="#575757"
  //       />
  //     </svg>
  //   ),
  //   name: "Feature Request",
  //   url: "",
  //   click: "",
  // },
  // {
  //   icon: (
  //     <svg
  //       width="20"
  //       height="21"
  //       viewBox="0 0 20 21"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <g clip-path="url(#clip0_2186_9820)">
  //         <path
  //           fill-rule="evenodd"
  //           clip-rule="evenodd"
  //           d="M8.90428 4.78487C8.6536 5.21952 8.29289 5.58048 7.85841 5.83145C7.42394 6.08242 6.93104 6.21456 6.42929 6.21456C5.92753 6.21456 5.43463 6.08242 5.00016 5.83145C4.56569 5.58048 4.20497 5.21952 3.95429 4.78487L1.42857 4.78487C1.04969 4.78487 0.686328 4.63436 0.418419 4.36645C0.15051 4.09855 2.50463e-08 3.73518 3.08351e-08 3.3563C3.66239e-08 2.97742 0.15051 2.61406 0.418419 2.34615C0.686328 2.07824 1.04969 1.92773 1.42857 1.92773L3.95429 1.92773C4.20497 1.49309 4.56569 1.13213 5.00016 0.881153C5.43463 0.630179 5.92753 0.498047 6.42929 0.498047C6.93104 0.498047 7.42394 0.630179 7.85841 0.881153C8.29289 1.13213 8.6536 1.49309 8.90428 1.92773L15.3571 1.92773C16.5885 1.92773 17.7694 2.41689 18.6401 3.28759C19.5108 4.1583 20 5.33923 20 6.57059C20 7.80195 19.5108 8.98288 18.6401 9.85358C17.7694 10.7243 16.5885 11.2134 15.3571 11.2134L14.6186 11.2134C14.368 11.6484 14.0072 12.0097 13.5726 12.2609C13.138 12.5121 12.6448 12.6444 12.1429 12.6444C11.6409 12.6444 11.1477 12.5121 10.7131 12.2609C10.2785 12.0097 9.91773 11.6484 9.66714 11.2134L5 11.2134C4.43168 11.2134 3.88663 11.4392 3.48477 11.8411C3.08291 12.2429 2.85714 12.788 2.85714 13.3563C2.85714 13.9246 3.08291 14.4697 3.48477 14.8715C3.88663 15.2734 4.43168 15.4992 5 15.4992L5.38286 15.4992C5.63363 15.0649 5.99431 14.7042 6.42863 14.4535C6.86296 14.2027 7.35563 14.0707 7.85714 14.0707C8.35865 14.0707 8.85132 14.2027 9.28565 14.4535C9.71998 14.7042 10.0807 15.0649 10.3314 15.4992L15.7143 15.4992L15.7143 14.0706C15.714 13.9291 15.7558 13.7908 15.8343 13.6731C15.9127 13.5554 16.0244 13.4636 16.1551 13.4095C16.2857 13.3553 16.4295 13.3412 16.5683 13.3688C16.707 13.3965 16.8344 13.4647 16.9343 13.5649L19.7914 16.422C19.9253 16.556 20.0006 16.7376 20.0006 16.927C20.0006 17.1164 19.9253 17.2981 19.7914 17.432L16.9343 20.2892C16.8345 20.3892 16.7072 20.4574 16.5686 20.4851C16.43 20.5129 16.2863 20.4988 16.1557 20.4448C16.0251 20.3908 15.9134 20.2993 15.8349 20.1818C15.7563 20.0644 15.7143 19.9262 15.7143 19.7849L15.7143 18.3563L10.3329 18.3563C10.0823 18.7913 9.72151 19.1526 9.28689 19.4038C8.85227 19.655 8.35914 19.7872 7.85714 19.7872C7.35515 19.7872 6.86202 19.655 6.4274 19.4038C5.99278 19.1526 5.63201 18.7913 5.38143 18.3563L5 18.3563C4.34339 18.3563 3.69321 18.227 3.08658 17.9757C2.47995 17.7244 1.92876 17.3561 1.46447 16.8918C1.00017 16.4275 0.631876 15.8763 0.380602 15.2697C0.129329 14.6631 -2.06491e-07 14.0129 -1.96459e-07 13.3563C-1.86426e-07 12.6997 0.129329 12.0495 0.380602 11.4429C0.631876 10.8363 1.00017 10.2851 1.46447 9.82077C1.92876 9.35647 2.47995 8.98818 3.08658 8.7369C3.69321 8.48563 4.34339 8.3563 5 8.3563L9.66857 8.3563C9.91935 7.922 10.28 7.56135 10.7143 7.3106C11.1487 7.05986 11.6413 6.92786 12.1429 6.92786C12.6444 6.92786 13.137 7.05986 13.5714 7.3106C14.0057 7.56135 14.3664 7.922 14.6171 8.3563L15.3571 8.3563C15.8307 8.3563 16.2849 8.16816 16.6198 7.83328C16.9547 7.49839 17.1429 7.04419 17.1429 6.57059C17.1429 6.09699 16.9547 5.64278 16.6198 5.3079C16.2849 4.97301 15.8307 4.78487 15.3571 4.78487L8.90428 4.78487Z"
  //           fill="#575757"
  //         />
  //       </g>
  //       <defs>
  //         <clipPath id="clip0_2186_9820">
  //           <rect
  //             width="20"
  //             height="20"
  //             fill="white"
  //             transform="translate(0 0.5)"
  //           />
  //         </clipPath>
  //       </defs>
  //     </svg>
  //   ),
  //   name: "Roadmaps",
  //   url: "",
  //   click: "",
  // },
  // {
  //   icon: (
  //     <svg
  //       width="20"
  //       height="21"
  //       viewBox="0 0 20 21"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M4.36167 6.94102C4.96258 5.98897 5.7948 5.20461 6.78073 4.66108C7.76666 4.11755 8.87418 3.83256 10 3.83268C11.126 3.83242 12.2337 4.11735 13.2197 4.66088C14.2058 5.20442 15.0382 5.98885 15.6392 6.94102L17.0475 6.04935C16.2962 4.85974 15.2558 3.87974 14.0235 3.2007C12.7912 2.52167 11.407 2.16571 10 2.16602C8.59313 2.16585 7.20911 2.52188 5.97695 3.20091C4.74479 3.87993 3.7046 4.85986 2.95333 6.04935L4.36167 6.94102ZM10 17.166C8.87418 17.1661 7.76666 16.8811 6.78073 16.3376C5.7948 15.7941 4.96258 15.0097 4.36167 14.0577L2.95333 14.9493C3.7046 16.1388 4.74479 17.1188 5.97695 17.7978C7.20911 18.4768 8.59313 18.8328 10 18.8327C11.407 18.833 12.7912 18.477 14.0235 17.798C15.2558 17.119 16.2962 16.139 17.0475 14.9493L15.6392 14.0577C15.0382 15.0098 14.2058 15.7943 13.2197 16.3378C12.2337 16.8814 11.126 17.1663 10 17.166ZM10 10.4993C10.663 10.4993 11.2989 10.236 11.7678 9.76712C12.2366 9.29828 12.5 8.66239 12.5 7.99935C12.5 7.33631 12.2366 6.70042 11.7678 6.23158C11.2989 5.76274 10.663 5.49935 10 5.49935C9.33696 5.49935 8.70107 5.76274 8.23223 6.23158C7.76339 6.70042 7.5 7.33631 7.5 7.99935C7.5 8.66239 7.76339 9.29828 8.23223 9.76712C8.70107 10.236 9.33696 10.4993 10 10.4993ZM10 11.3327C10.8841 11.3327 11.7319 11.6839 12.357 12.309C12.9821 12.9341 13.3333 13.782 13.3333 14.666L6.66667 14.666C6.66667 13.782 7.01786 12.9341 7.64298 12.309C8.2681 11.6839 9.11594 11.3327 10 11.3327ZM5 10.4993C5 11.1624 4.73661 11.7983 4.26777 12.2671C3.79893 12.736 3.16304 12.9993 2.5 12.9993C1.83696 12.9993 1.20107 12.736 0.732233 12.2671C0.263392 11.7983 -1.37454e-07 11.1624 -1.27323e-07 10.4993C-1.17193e-07 9.83631 0.263392 9.20042 0.732233 8.73158C1.20107 8.26274 1.83696 7.99935 2.5 7.99935C3.16304 7.99935 3.79893 8.26274 4.26777 8.73158C4.73661 9.20042 5 9.83631 5 10.4993ZM17.5 12.9993C18.163 12.9993 18.7989 12.736 19.2678 12.2671C19.7366 11.7983 20 11.1624 20 10.4993C20 9.83631 19.7366 9.20042 19.2678 8.73158C18.7989 8.26274 18.163 7.99935 17.5 7.99935C16.837 7.99935 16.2011 8.26274 15.7322 8.73158C15.2634 9.20042 15 9.83631 15 10.4993C15 11.1624 15.2634 11.7983 15.7322 12.2671C16.2011 12.736 16.837 12.9993 17.5 12.9993Z"
  //         fill="#575757"
  //       />
  //     </svg>
  //   ),
  //   name: "Community",
  //   url: "",
  //   click: "",
  // },
  {
    icon: (
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.99667 2.37073C10.5442 2.0224 11.6667 3.3524 11.6667 4.6674V16.3341C11.6667 17.6491 10.5442 18.9791 8.99667 18.6307C5.27833 17.7941 2.5 14.4724 2.5 10.5007C2.5 6.52907 5.27833 3.2074 8.99667 2.37073ZM13.5775 7.41157C13.7338 7.25534 13.9457 7.16758 14.1667 7.16758C14.3876 7.16758 14.5996 7.25534 14.7558 7.41157L17.2558 9.91157C17.4121 10.0678 17.4998 10.2798 17.4998 10.5007C17.4998 10.7217 17.4121 10.9336 17.2558 11.0899L14.7558 13.5899C14.5987 13.7417 14.3882 13.8257 14.1697 13.8238C13.9512 13.8219 13.7422 13.7343 13.5877 13.5798C13.4331 13.4252 13.3455 13.2162 13.3436 12.9977C13.3417 12.7792 13.4257 12.5687 13.5775 12.4116L14.655 11.3341H7.5C7.27899 11.3341 7.06702 11.2463 6.91074 11.09C6.75446 10.9337 6.66667 10.7217 6.66667 10.5007C6.66667 10.2797 6.75446 10.0678 6.91074 9.91148C7.06702 9.7552 7.27899 9.6674 7.5 9.6674H14.655L13.5775 8.5899C13.4213 8.43363 13.3335 8.2217 13.3335 8.00073C13.3335 7.77976 13.4213 7.56784 13.5775 7.41157Z"
          fill="#575757"
        />
      </svg>
    ),
    name: "Logout",
    // url: "/login",
    url: "/login",
    click: "logout",
  },
];

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : "#dfca6f",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,.35)"
        : "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const drawerWidth = 250;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawers = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function Sidebar() {
  const notify = () => toast.success("Password Updated");
  const remove = () => toast.success("Deleted successfully");

  //   image upload
  const [state, setState] = useState("");
  // const handleChange = (event) => {
  //   setState(event.target.value);
  // };

  //   password
  const [password, setPassword] = useState();
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  //newpassowrd
  const [showNewPassword, setShowNewPassword] = React.useState(false);

  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);

  //confirmpassword

  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickConfirmShowPassword = () =>
    setShowConfirmPassword((show) => !show);

  const [confPassErr, setConfPassErr] = useState("");

  const checkconfirmpass = (e) => {
    if (password != e) {
      setConfPassErr("Password Mismatching");
    } else {
      setConfPassErr("");
    }
  };

  const [sameMap, setsameMap] = React.useState(false);
  const [expandedMap, setExpandedMap] = React.useState(false);

  const handleExpandClickMap = () => {
    setsameMap(false);
    setExpandedMap(!expandedMap);
  };
  const handleExpandClickSameMap = () => {
    setExpandedMap(false);
    setsameMap(!sameMap);
  };

  const [pop, setPop] = useState(false);
  const handlePopOpen = () => {
    setPop(true);
    getAllUserDetails();
  };
  const handlePopClose = () => setPop(false);
  const theme = useTheme();
  const isLgup = useMediaQuery(theme.breakpoints.up("lg"));

  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const mobileUp = useMediaQuery(theme.breakpoints.up("sm"));
  const medium = useMediaQuery(theme.breakpoints.up("lg"));

  const navigate = useNavigate();

  const [open, setOpen] = useState(true);
  const { isLightMode, handleDarkmode } = useContext(ThemeContext);
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const loaction = useLocation();

  const activeFil = loaction.pathname.toLocaleLowerCase();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open2 = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openPop = Boolean(anchorEl);
  const id = openPop ? "simple-popover" : undefined;

  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl2(null);
  };

  const openPop2 = Boolean(anchorEl2);
  const id2 = openPop2 ? "simple-popover" : undefined;

  // useEffect(() => {
  //     setOpen(false);
  // }, [open]);
  const [userName, setUserName] = useState("");
  const [userDetail, setUserDetail] = useState({});

  useEffect(() => {
    const name = localStorage.getItem("userName");
    setUserName(name);
    // const detail = localStorage.getItem("UserDetails");
    // setAllUsers(JSON.parse(detail));
  }, []);

  useEffect(() => {
    if (!isLgup) {
      setOpen(false);
    }
  }, [isLgup]);

  const [expanded, setExpanded] = useState(null);

  const [allUsers, setAllUsers] = useState({
    firstName: "",
    lastName: "",
    email: "",
    oldpassword: "",
    newpassword: "",
    confirmpassword: "",
    profileimage: "",
    changepassword: false,
  });

  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    oldpassword: "",
    newpassword: "",
    confirmpassword: "",
  });
  const [load, setLoad] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  useEffect(() => {
    // if (expandedMap === true) {
      getAllUserDetails();
    // }
    // const data = localStorage.getItem("UserDetails");
    // setAllUsers(JSON.parse(data));
  }, []);

  const getAllUserDetails = async () => {
    const response = await getUserDetails();
    if (response?.data?.success === true) {
      setAllUsers(response?.data?.result);
      const data = response?.data?.result;
      localStorage.setItem("UserDetails", JSON.stringify(data));
    } else {
    }
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAllUsers({
      ...allUsers,
      [name]: value,
      changepassword: expandedMap === true ? true : false,
    });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    // setProfileImage(file);

    setAllUsers({
      ...allUsers,
      changepassword: expandedMap === true ? true : false,
      profileimage: file,
    });
    reader.onloadend = () => {
      setImageUrl(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const validateFocus = (e) => {
    const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{6,}$/;
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue?.trim();
    const fieldId = e?.target?.id;

    let isValid = true;
    let errorMessage = "";

    // Handle empty field validation
    if (value === "" || value === undefined) {
      // errorMessage = `${fieldName} is required`;
      // isValid = false;
    } else if (fieldValue.length < 5) {
      errorMessage = `${fieldName} must be 5 characters`;
      isValid = false;
    }

    // Handle email validation
    // if (fieldName === "email") {
    //   if (value === "" || value === undefined) {
    //     errorMessage = "Email is required";
    //     isValid = false;
    //   } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
    //     errorMessage = "Email is invalid";
    //     isValid = false;
    //   }
    // }

    // Handle password validation
    if (expandedMap === true) {
      if (
        fieldName === "oldpassword" ||
        fieldName === "newpassword" ||
        fieldName === "confirmpassword"
      ) {
        if (value === "" || value === undefined) {
          // errorMessage = `${fieldName} is required`;
          // isValid = false;
        } else if (!passwordRegex.test(value)) {
          if (fieldName === "oldpassword") {
            errorMessage = `Old Password must contain at least 6 characters, one uppercase letter, one special character, and one number`;
            isValid = false;
          }
          if (fieldName === "newpassword") {
            errorMessage = `New Password must contain at least 6 characters, one uppercase letter, one special character, and one number`;
            isValid = false;
          }
          if (fieldName === "confirmpassword") {
            errorMessage = `Confirm Password must contain at least 6 characters, one uppercase letter, one special character, and one number`;
            isValid = false;
          }
        } else if (
          fieldName === "confirmpassword" &&
          allUsers.newpassword != value
        ) {
          errorMessage = `Password doesnot match`;
          isValid = false;
        }
      }
    }

    // Set errors after validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    //validate firstname and last name
    if (!allUsers.firstName) {
      formErrors.firstName = "First Name is required";
      isValid = false;
    } else if (!allUsers.firstName) {
      formErrors.firstName = "First Name must be 5 characters";
      isValid = false;
    } else if (!allUsers.lastName) {
      formErrors.lastName = "Last Name is required";
      isValid = false;
    }
    // Validate password
    if (expandedMap === true) {
      if (!allUsers.oldpassword) {
        formErrors.oldpassword = "Old Password is required";
        isValid = false;
      }
      if (!allUsers.newpassword) {
        formErrors.newpassword = "New Password is required";
        isValid = false;
      }
      if (!allUsers.confirmpassword) {
        formErrors.confirmpassword = "Confirm Password is required";
        isValid = false;
      }
      if (allUsers?.newpassword?.length < 6) {
        formErrors.newpassword =
          "New Password must be at least 8 characters long";
        isValid = false;
      }
      if (!/^[A-Z]/.test(allUsers.newpassword)) {
        formErrors.newpassword =
          "New Password must start with a capital letter";
        isValid = false;
      }
      if (allUsers?.confirmpassword?.length < 6) {
        formErrors.confirmpassword =
          "Confirm Password must be at least 8 characters long";
        isValid = false;
      }
      if (!/^[A-Z]/.test(allUsers.confirmpassword)) {
        formErrors.confirmpassword =
          "Confirm Password must start with a capital letter";
        isValid = false;
      }
      if (allUsers.newpassword != allUsers.confirmpassword) {
        formErrors.confirmpassword = "Confirm Password does not match";
        isValid = false;
      }
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();

    if (validate()) {
      // var changePassword=false;

      setLoad(true);
      const formdata = new FormData();
      if (expandedMap === false) {
        formdata.append("firstname", allUsers.firstName);
        formdata.append("lastname", allUsers.lastName);
        formdata.append("email", allUsers.email);
        formdata.append("changepassword", expandedMap);
        formdata.append("image", allUsers.profileimage);
      } else {
        formdata.append("firstname", allUsers.firstName);
        formdata.append("lastname", allUsers.lastName);
        formdata.append("email", allUsers.email);
        formdata.append("changepassword", expandedMap);
        formdata.append("image", allUsers.profileimage);
        formdata.append("oldpassword", allUsers.oldpassword);
        formdata.append("newpassword", allUsers.newpassword);
        formdata.append("confirmpassword", allUsers.confirmpassword);
      }

      const response = await updateOneUser(formdata);
      if (response?.data?.success === true) {
        toast.success(response.data.message);
        handlePopClose();
        getAllUserDetails();

        setLoad(false);
        setExpandedMap(false);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
        setExpandedMap(false);
      }
    }
  };

  const [routes, setRoutes] = useState([
    {
      name: "Assitant",
      svg: <GroupIcon />,
      // path: "/assistant",
      path: "/",
    },
    {
      name: "Contact List",
      svg: <AccountBoxIcon />,
      path: "/contact-list",
    },
    {
      name: "My Phone Number",
      svg: <LocalPhoneIcon />,
      path: "/phone-number",
    },

    {
      name: "Campaign",
      svg: <CampaignIcon />,
      path: "/campaign",
    },

    {
      name: "Call History",
      svg: <HistoryIcon />,
      path: "/call-history",
    },

    {
      name: "Support",
      svg: (
        <svg
          width="15"
          height="20"
          viewBox="0 0 15 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.36652 13.7078L5.36517 13.7038L5.10848 13.62C3.88766 13.1885 2.81659 12.4152 2.02281 11.3922C1.38093 10.5656 0.939883 9.60124 0.734456 8.57507C0.529029 7.5489 0.564841 6.48904 0.839066 5.47908C1.11329 4.46912 1.61843 3.53669 2.31464 2.75533C3.01084 1.97398 3.87908 1.36508 4.85085 0.976649C5.82262 0.588223 6.87136 0.4309 7.91433 0.517089C8.9573 0.603279 9.96598 0.930623 10.8608 1.4733C11.7556 2.01598 12.5121 2.75915 13.0706 3.64419C13.6291 4.52923 13.9744 5.53194 14.0791 6.57321C14.1155 6.94473 13.8089 7.24736 13.436 7.24736C13.0631 7.24736 12.7646 6.94338 12.72 6.57321C12.5994 5.61783 12.2257 4.71202 11.6376 3.94951C11.0495 3.187 10.2684 2.59548 9.37494 2.23617C8.48153 1.87686 7.50833 1.7628 6.55605 1.90579C5.60377 2.04879 4.707 2.44365 3.95852 3.04951C3.21004 3.65538 2.63705 4.45023 2.29884 5.35184C1.96062 6.25345 1.86947 7.22906 2.03481 8.17772C2.20015 9.12638 2.61598 10.0136 3.23927 10.7477C3.86256 11.4817 4.67066 12.0358 5.57997 12.3528C5.80934 11.9344 6.17895 11.6104 6.62372 11.4378C7.0685 11.2652 7.55991 11.255 8.01143 11.4091C8.46296 11.5632 8.84563 11.8717 9.09208 12.2802C9.33853 12.6887 9.43295 13.1711 9.35871 13.6424C9.28447 14.1136 9.04634 14.5436 8.68623 14.8566C8.32613 15.1695 7.86716 15.3454 7.39013 15.3532C6.9131 15.3611 6.44861 15.2003 6.07844 14.8993C5.70827 14.5983 5.45617 14.1764 5.36652 13.7078ZM4.29518 14.7548C2.97202 14.2146 1.81521 13.3342 0.942013 12.2028C0.720065 12.5357 0.601606 12.9268 0.601562 13.3268V14.0023C0.601562 16.6651 3.11441 19.4063 7.35653 19.4063C11.5986 19.4063 14.1115 16.6651 14.1115 14.0023V13.3268C14.1115 12.7894 13.898 12.2739 13.518 11.8939C13.1379 11.5138 12.6225 11.3003 12.085 11.3003H10.0585C10.3419 11.6788 10.5426 12.1125 10.6478 12.5734C10.753 13.0343 10.7602 13.5121 10.669 13.976C10.5779 14.4399 10.3903 14.8795 10.1186 15.2663C9.84679 15.6531 9.49684 15.9786 9.09135 16.2217C8.68585 16.4647 8.23385 16.6199 7.76459 16.6773C7.29532 16.7346 6.81924 16.6928 6.36716 16.5545C5.91507 16.4163 5.49705 16.1846 5.14013 15.8746C4.78322 15.5646 4.49536 15.1831 4.29518 14.7548ZM11.4095 7.24736C11.4095 6.01255 10.857 4.90609 9.98556 4.16304C9.5601 3.80266 9.06486 3.53394 8.53081 3.37369C7.99675 3.21345 7.43538 3.16512 6.8818 3.23173C6.32822 3.29834 5.79433 3.47846 5.31353 3.76081C4.83274 4.04317 4.41538 4.4217 4.08755 4.87272C3.75972 5.32374 3.52848 5.83755 3.40829 6.38202C3.2881 6.92649 3.28154 7.4899 3.38903 8.03702C3.49652 8.58413 3.71574 9.10319 4.03299 9.56171C4.35023 10.0202 4.75867 10.4084 5.23277 10.7018C5.83351 10.2148 6.58318 9.94873 7.35653 9.94799C8.12955 9.94796 8.87919 10.2131 9.48029 10.6991C10.0699 10.3364 10.5567 9.82874 10.8944 9.22449C11.2321 8.62025 11.4095 7.93957 11.4095 7.24736Z"
            fill="white"
          />
        </svg>
      ),

      path: "/support",
    },
    {
      name: "Developer API",
      svg: <AppsIcon />,

      path: "/api-developer",
    },

    {
      name: "Pricing",
      svg: (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.4467 4.43955L14.9717 5.96455C17.2126 8.20622 18.3326 9.32622 18.3326 10.7179C18.3326 12.1104 17.2126 13.2304 14.9717 15.4712C12.7301 17.7129 11.6101 18.8329 10.2176 18.8329C8.8259 18.8329 7.70507 17.7129 5.46424 15.4721L3.93924 13.9471C2.65174 12.6587 2.00757 12.0154 1.7684 11.1796C1.5284 10.3437 1.7334 9.45622 2.1434 7.68205L2.37924 6.65872C2.7234 5.16539 2.8959 4.41872 3.40674 3.90705C3.91757 3.39539 4.66507 3.22372 6.1584 2.87955L7.18174 2.64289C8.95674 2.23372 9.8434 2.02872 10.6792 2.26789C11.5151 2.50789 12.1592 3.15205 13.4467 4.43955ZM9.28757 12.4396C8.72674 11.8796 8.7309 11.0746 9.06674 10.4371C8.9836 10.317 8.94514 10.1716 8.95805 10.0261C8.97095 9.88057 9.03441 9.7442 9.13739 9.64062C9.24037 9.53704 9.37638 9.47281 9.52179 9.45906C9.66721 9.44532 9.81284 9.48294 9.9334 9.56539C10.2167 9.41539 10.5276 9.33539 10.8376 9.33872C11.0033 9.34027 11.1617 9.4076 11.2778 9.5259C11.3939 9.64421 11.4583 9.80379 11.4567 9.96955C11.4552 10.1353 11.3879 10.2937 11.2696 10.4098C11.1513 10.5259 10.9917 10.5903 10.8259 10.5887C10.6329 10.5959 10.4506 10.6788 10.3184 10.8196C9.9959 11.1421 10.0801 11.4654 10.1709 11.5562C10.2626 11.6471 10.5851 11.7312 10.9076 11.4087C11.5609 10.7554 12.6892 10.5387 13.4117 11.2612C13.9726 11.8221 13.9684 12.6271 13.6326 13.2646C13.7152 13.3847 13.7532 13.5299 13.7401 13.6751C13.7269 13.8203 13.6635 13.9563 13.5606 14.0596C13.4578 14.163 13.3221 14.2271 13.1769 14.2409C13.0318 14.2548 12.8864 14.2174 12.7659 14.1354C12.392 14.3406 11.9582 14.4089 11.5392 14.3287C11.3768 14.2953 11.2343 14.1988 11.143 14.0603C11.0517 13.9219 11.0192 13.7528 11.0526 13.5904C11.0859 13.4279 11.1825 13.2854 11.3209 13.1941C11.4594 13.1029 11.6285 13.0703 11.7909 13.1037C11.9384 13.1346 12.1767 13.0862 12.3809 12.8821C12.7034 12.5587 12.6192 12.2362 12.5284 12.1454C12.4367 12.0546 12.1142 11.9704 11.7917 12.2929C11.1384 12.9462 10.0101 13.1629 9.28757 12.4396ZM8.34924 9.07705C8.50398 8.92226 8.62671 8.7385 8.71044 8.53627C8.79416 8.33404 8.83724 8.1173 8.8372 7.89843C8.83716 7.67955 8.79401 7.46283 8.71021 7.26063C8.62642 7.05843 8.50362 6.87471 8.34882 6.71997C8.19402 6.56523 8.01027 6.44249 7.80804 6.35877C7.60581 6.27504 7.38907 6.23197 7.17019 6.23201C6.95132 6.23205 6.73459 6.2752 6.53239 6.35899C6.33019 6.44279 6.14648 6.56559 5.99174 6.72039C5.67922 7.03301 5.5037 7.45698 5.50378 7.89902C5.50386 8.34105 5.67953 8.76496 5.99215 9.07747C6.30478 9.38998 6.72874 9.56551 7.17078 9.56543C7.61282 9.56535 8.03672 9.38968 8.34924 9.07705Z"
            fill="#575757"
          />
        </svg>
      ),

      path: "/pricing",
    },
    // {
    //   name: "Documentation",
    //   svg: <DescriptionIcon />,

    //   path: "",
    // },
    {
      name: "Logout",
      svg: <LogoutIcon className="logout-icon" />,

      path: "/login",
      // path:"",
      click: "logout",
    },
  ]);

  //
  const [anchorProfileEl, setAnchorProfileEl] = useState(null);

  const handleProfileClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (state) => () => {
    setOpen(state);
  };

  const { logout } = useAuth();
  // const breadcrumbs = [
  //   <Link underline="hover" key="1" color="inherit" to="/">
  //     MUI
  //   </Link>,

  //   <Typography key="2" sx={{ color: "text.primary" }}>
  //     Breadcrumb
  //   </Typography>,
  // ];

  const open1 = Boolean(anchorEl);
  const id1 = open ? "simple-popover" : undefined;
  //

  const drawer = (
    <>
      {/* <DrawerHeader className='drawhead'>
                <div onClick={(() => { navigate('/') })} className='cursor'>
                    {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                    <div className="apxlogo">
            <img src={logo} alt="apx" />
          </div>

                </div>
            </DrawerHeader> */}

      <List className="listmui">
        <div
          onClick={() => {
            navigate("/");
          }}
          className="cursor"
        >
          {/* {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />} */}
          <div className="apxlogo logo-fixed">
            <img src={logo} alt="apx" />
          </div>
        </div>
        <div className="mt-20">
          {routes.map((row, index) => (
            <div key={index} className="side-link">
              <NavLink
                className={({ isActive }) => (isActive ? "active" : "")}
                to={row.path}
                onClick={() => {
                  if (row.click === "logout") {
                    logout();
                  } else if (row.children) {
                    // Toggle dropdown for this route
                    setExpanded(expanded === index ? null : index);
                  } else {
                    setOpen(true);
                    setExpanded(null); // Close dropdown if navigating elsewhere
                  }
                }}
              >
                <ListItem
                  disablePadding
                  sx={{ display: "block" }}
                  className="routelist"
                >
                  <ListItemButton
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                    className="icobtn"
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 2 : "auto",
                        justifyContent: "center",
                      }}
                    >
                      {row.svg}
                    </ListItemIcon>
                    <ListItemText
                      className="routetext"
                      primary={row.name}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                    <ListItemIcon style={{ justifyContent: "end" }}>
                      {row.icon}
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
              </NavLink>
              {/* Render Dropdown */}
              {row.children && expanded === index && (
                <List component="div" disablePadding>
                  {row.children.map((child, childIndex) => (
                    <NavLink
                      key={childIndex}
                      to={child.path}
                      onClick={() => setOpen(false)}
                    >
                      <ListItem
                        disablePadding
                        sx={{ pl: open ? 4 : 2 }}
                        className="child-routelist"
                      >
                        <ListItemButton>
                          <ListItemText
                            primary={child.name}
                            className="drop-list"
                          />
                        </ListItemButton>
                      </ListItem>
                    </NavLink>
                  ))}
                </List>
              )}
            </div>
          ))}
        </div>
      </List>
    </>
  );

  const darkMode = (
    <div className="text-center">
      <Darkmode />
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        open={open}
        className="sidetoolbar"
        sx={{ width: !isLgup ? "100%" : "calc(100%-200px)" }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            paddingLeft: "0px !important",
          }}
        >
          {!isLgup ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={open ? handleDrawerClose : handleDrawerOpen}
              sx={{ mr: 2 }}
              className="menu-btn-padding"
            >
              {open ? (
                <svg
                  width="30"
                  height="17"
                  viewBox="0 0 30 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1.5H20.4444"
                    stroke="black"
                    stroke-width="1.55556"
                    stroke-linecap="round"
                  />
                  <path
                    d="M1 7.72222C0.570445 7.72222 0.222222 8.07045 0.222222 8.5C0.222222 8.92955 0.570445 9.27778 1 9.27778V7.72222ZM29.55 9.04997C29.8537 8.74623 29.8537 8.25377 29.55 7.95003L24.6002 3.00028C24.2965 2.69654 23.804 2.69654 23.5003 3.00028C23.1965 3.30402 23.1965 3.79648 23.5003 4.10022L27.9001 8.5L23.5003 12.8998C23.1965 13.2035 23.1965 13.696 23.5003 13.9997C23.804 14.3035 24.2965 14.3035 24.6002 13.9997L29.55 9.04997ZM1 9.27778H29V7.72222H1V9.27778Z"
                    fill="black"
                  />
                  <path
                    d="M1 15.5H20.4444"
                    stroke="black"
                    stroke-width="1.55556"
                    stroke-linecap="round"
                  />
                </svg>
              ) : (
                // <MenuOpenIcon className="menu-close-icon" />
                <svg
                  width="30"
                  height="17"
                  viewBox="0 0 30 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1.5H20.4444"
                    stroke="black"
                    stroke-width="1.55556"
                    stroke-linecap="round"
                  />
                  <path
                    d="M1 7.72222C0.570445 7.72222 0.222222 8.07045 0.222222 8.5C0.222222 8.92955 0.570445 9.27778 1 9.27778V7.72222ZM29.55 9.04997C29.8537 8.74623 29.8537 8.25377 29.55 7.95003L24.6002 3.00028C24.2965 2.69654 23.804 2.69654 23.5003 3.00028C23.1965 3.30402 23.1965 3.79648 23.5003 4.10022L27.9001 8.5L23.5003 12.8998C23.1965 13.2035 23.1965 13.696 23.5003 13.9997C23.804 14.3035 24.2965 14.3035 24.6002 13.9997L29.55 9.04997ZM1 9.27778H29V7.72222H1V9.27778Z"
                    fill="black"
                  />
                  <path
                    d="M1 15.5H20.4444"
                    stroke="black"
                    stroke-width="1.55556"
                    stroke-linecap="round"
                  />
                </svg>
              )}
              {/* <MenuIcon sx={{ fill: '#000' }} /> */}
            </IconButton>
          ) : (
            <div
              color="inherit"
              aria-label="open drawer"
              onClick={open ? handleDrawerClose : handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
              }}
            >
              {/* <div className="apxlogo cursor">
                {open ? <MenuOpenIcon className="menu-close-icon" /> : <FormatAlignLeftIcon className="menu-clr" />}
              </div> */}
              <div className="apxlogo cursor display-1">
                {open ? (
                  <div className="menu-close-icon">
                    {/* <MenuOpenIcon className="menu-close-icon" /> */}
                    <svg
                      width="30"
                      height="17"
                      viewBox="0 0 30 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5H20.4444"
                        stroke="white"
                        stroke-width="1.55556"
                        stroke-linecap="round"
                      />
                      <path
                        d="M1 7.72222C0.570445 7.72222 0.222222 8.07045 0.222222 8.5C0.222222 8.92955 0.570445 9.27778 1 9.27778V7.72222ZM29.55 9.04997C29.8537 8.74623 29.8537 8.25377 29.55 7.95003L24.6002 3.00028C24.2965 2.69654 23.804 2.69654 23.5003 3.00028C23.1965 3.30402 23.1965 3.79648 23.5003 4.10022L27.9001 8.5L23.5003 12.8998C23.1965 13.2035 23.1965 13.696 23.5003 13.9997C23.804 14.3035 24.2965 14.3035 24.6002 13.9997L29.55 9.04997ZM1 9.27778H29V7.72222H1V9.27778Z"
                        fill="white"
                      />
                      <path
                        d="M1 15.5H20.4444"
                        stroke="white"
                        stroke-width="1.55556"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                ) : (
                  <div className="menu-part">
                    {/* <FormatAlignLeftIcon className="menu-clr" /> */}
                    <svg
                      width="30"
                      height="17"
                      viewBox="0 0 30 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5H20.4444"
                        stroke="white"
                        stroke-width="1.55556"
                        stroke-linecap="round"
                      />
                      <path
                        d="M1 7.72222C0.570445 7.72222 0.222222 8.07045 0.222222 8.5C0.222222 8.92955 0.570445 9.27778 1 9.27778V7.72222ZM29.55 9.04997C29.8537 8.74623 29.8537 8.25377 29.55 7.95003L24.6002 3.00028C24.2965 2.69654 23.804 2.69654 23.5003 3.00028C23.1965 3.30402 23.1965 3.79648 23.5003 4.10022L27.9001 8.5L23.5003 12.8998C23.1965 13.2035 23.1965 13.696 23.5003 13.9997C23.804 14.3035 24.2965 14.3035 24.6002 13.9997L29.55 9.04997ZM1 9.27778H29V7.72222H1V9.27778Z"
                        fill="white"
                      />
                      <path
                        d="M1 15.5H20.4444"
                        stroke="white"
                        stroke-width="1.55556"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                )}
                <div className="breadcrumb-link">
                  {/* <Breadcrumbs separator="›" aria-label="breadcrumb">
                    {breadcrumbs}
                  </Breadcrumbs> */}
                  <Breadcrumb />
                </div>
              </div>
            </div>
          )}

          {/* <Stack direction="row" spacing={4} sx={{ alignItems: "center" }}>
            <List>{darkMode}</List>

            <IconButton
              onClick={handleOpenUserMenu}
              sx={{ p: 0 }}
              className="profile-btn display-1"
            >
            
           
                       
              <div className="alen-profile">
                
                <p>Alen G</p>
                <span>Admin</span>
              </div>
              <div className="profile-img">
                <Avatar src="/broken-image.jpg" />
              </div>
            </IconButton>
            <Menu
              sx={{ mt: "4px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              className="mui-list profile-list"
            >



              {settings.map((setting) => (
                
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography
                    className="profile-set display-2"
                    textAlign="center"
                    onClick={() => navigate(setting.url)}
                  >
                    {setting.icon}
                    {setting.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Stack> */}

          <div className="apxlogo mobile-logo">
            <img src={logo} alt="apx" />
          </div>

          <div className="display-1 cursor profile-gap">
            <div className="alen-profile">
              {/* <p>Alen G</p> */}
              <p>{allUsers?.firstName}</p>
              {/* <span>Admin</span> */}
            </div>

            <div className="popover-box">
              <div className="profile-img">
                
                {allUsers?.profileimage === "" ? (
                  <Avatar  alt="" src="" onClick={handleProfileClick} />
                ) : (
                  <Avatar
                    src={allUsers?.profileimage}
                    onClick={handleProfileClick}
                  />
                )}
              </div>

              <Popover
                id={id1}
                open={open1}
                anchorEl={anchorProfileEl}
                onClose={handleProfileClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                className="pop-paper"
              >
                <div className="profile-dropdown">
                  <div className="gradient-bar"></div>

                  <div className="profile-img text-center popover-profile">
                    {/* <Avatar
                      src={
                        allUsers?.profileimage === ""
                          ? profile
                          : allUsers.profileimage
                      }
                      onClick={handleProfileClick}
                    /> */}
                    {allUsers?.profileimage === "" ? (
                  <Avatar  alt="" src="" onClick={handleProfileClick} />
                ) : (
                  <Avatar
                    src={allUsers?.profileimage}
                    onClick={handleProfileClick}
                  />
                )}
                    <div className="alen-profile">
                      {/* <p>Alen G</p> */}
                      <p>{allUsers?.firstName}</p>
                      {/* <span>alen@gmail.com</span> */}
                      <span>{allUsers?.email}</span>
                    </div>
                  </div>

                  <div className="nav-link-full mt--30">
                    {settings.map((row, i) => {
                      return (
                        <div
                          className="nav-link-full"
                          onClick={() =>
                            row.click === "open"
                              ? handlePopOpen()
                              : row.click === "logout"
                              ? logout()
                              : null
                          }
                        >
                          <NavLink
                            to={row.url}
                            style={{ textDecoration: "none" }}
                            className="profile-drowpdown-item display-1"
                          >
                            <div className="profile-icon d-flex">
                              {row.icon}
                            </div>
                            <div className="profile-content">
                              <Typography
                                variant="body1"
                                gutterBottom
                                sx={{ marginBottom: "0 !important" }}
                              >
                                {row.name}
                              </Typography>
                            </div>
                          </NavLink>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Popover>
            </div>

            <ArrowDropDownIcon
              sx={{ color: "#000", fontSize: "30px" }}
              onClick={handleProfileClick}
            />
          </div>
        </Toolbar>
      </AppBar>

      {isLgup ? (
        <Drawers
          variant={"permanent"}
          anchor="left" // Can be "left", "right", "top", or "bottom"
          open={open}
          onClose={toggleDrawer(false)}
          TransitionComponent={Slide} // Smooth Slide transition
          transitionDuration={{ enter: 1000, exit: 800 }}
        >
          {drawer}
        </Drawers>
      ) : (
        <Drawer variant={"temporary"} open={open}>
          {drawer}
        </Drawer>
      )}
      {/* <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <DrawerHeader />

            </Box> */}

      <Modal
        open={pop}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="common-modal-box EditProfile-popup">
          <div className="">
            <Grid
              container
              spacing={1}
              sx={{ display: "flex", mt: "20px", justifyContent: "center" }}
            >
              <Grid
                item
                size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
                sx={{ justifyContent: "center", textAlign: "center" }}
              >
                <div className="profile-upload">
                  <Avatar
                    alt=""
                    src={imageUrl != null ? imageUrl : allUsers.profileimage}
                  />
                  <Button
                    component="label"
                    role={undefined}
                    tabIndex={-1}
                    startIcon={<CameraAltIcon />}
                    className="pencil-icon"
                  >
                    <VisuallyHiddenInput
                      type="file"
                      onChange={handleImageUpload}
                      accept="image/png"
                    />
                  </Button>
                </div>
              </Grid>
              <Grid
                item
                size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}
                sx={{ justifyContent: "center" }}
              >
                <div className="input-common">
                  <label>First Name *</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    placeholder="Enter First Name"
                    name="firstName"
                    onChange={(e) => handleChange(e)}
                    onFocus={(e) => validateFocus(e)}
                    onInput={validateFocus}
                    error={!!errors.firstName}
                    helperText={errors.firstName}
                    value={allUsers.firstName}
                  />
                </div>
              </Grid>
              <Grid
                item
                size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}
                sx={{ justifyContent: "center" }}
              >
                <div className="input-common">
                  <label>Last Name *</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    placeholder="Enter Last Name"
                    name="lastName"
                    onChange={(e) => handleChange(e)}
                    onFocus={(e) => validateFocus(e)}
                    onInput={validateFocus}
                    error={!!errors.lastName}
                    helperText={errors.lastName}
                    value={allUsers.lastName}
                  />
                </div>
              </Grid>
              <Grid
                item
                size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
                sx={{ justifyContent: "center" }}
              >
                <div className="input-common">
                  <label>Email *</label>
                  <TextField
                    fullWidth
                    id="fullWidth"
                    placeholder="@gmail.com"
                    name="email"
                    onChange={(e) => handleChange(e)}
                    onFocus={(e) => validateFocus(e)}
                    onInput={validateFocus}
                    error={!!errors.email}
                    helperText={errors.email}
                    value={allUsers.email}
                    disabled
                  />
                </div>
                <div className="reg-forget mt-10 display-4">
                  <Link onClick={handleExpandClickMap}>Change Password</Link>
                </div>
              </Grid>

              {/* <Grid
                item
                size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
                sx={{ justifyContent: "center" }}
              >
                <div className="input-common">
                  <label>Password</label>
                  <FormControl sx={{ mt: 1, width: "100%" }} variant="outlined">
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      placeholder="********"
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            className="eye-icon"
                            aria-label={
                              showPassword
                                ? "hide the password"
                                : "display the password"
                            }
                            onClick={handleClickShowPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>

                <div className="reg-forget mt-10 display-4">
                  <Link onClick={handleExpandClickMap}>Change Password</Link>
                </div>
              </Grid> */}

              <Collapse in={expandedMap} timeout="auto" unmountOnExit>
                <Grid
                  item
                  size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
                  sx={{ justifyContent: "center" }}
                >
                  <Grid container spacing={1}>
                    <Grid
                      item
                      size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
                      sx={{ justifyContent: "center" }}
                    >
                      <div className="input-common">
                        <label>Old Password *</label>
                        <FormControl
                          sx={{ mt: 1, width: "100%" }}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? "text" : "password"}
                            // value={password}
                            placeholder="********"
                            // onChange={(e) => {
                            //   setPassword(e.target.value);
                            // }}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onFocus={validateFocus}
                            onInput={validateFocus}
                            error={!!errors.oldpassword}
                            value={allUsers.oldpassword}
                            // helperText={errors.password}
                            name="oldpassword"
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  className="eye-icon"
                                  aria-label={
                                    showPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickShowPassword}
                                  edge="end"
                                >
                                  {showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                        <span
                          style={{
                            color: "#d32f2f",
                            fontSize: 13,
                          }}
                        >
                          {errors.oldpassword}
                        </span>{" "}
                      </div>
                    </Grid>
                    <Grid
                      item
                      size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
                      sx={{ justifyContent: "center" }}
                    >
                      <div className="input-common">
                        <label>New Password *</label>
                        <FormControl
                          sx={{ mt: 1, width: "100%" }}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showNewPassword ? "text" : "password"}
                            // value={password}
                            placeholder="********"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onFocus={validateFocus}
                            onInput={validateFocus}
                            error={!!errors.newpassword}
                            value={allUsers.newpassword}
                            name="newpassword"
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  className="eye-icon"
                                  aria-label={
                                    showPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickShowNewPassword}
                                  edge="end"
                                >
                                  {showNewPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                        <span
                          style={{
                            color: "#d32f2f",
                            fontSize: 13,
                          }}
                        >
                          {errors.newpassword}
                        </span>{" "}
                      </div>
                    </Grid>
                    <Grid
                      item
                      size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}
                      sx={{ justifyContent: "center" }}
                    >
                      <div className="input-common">
                        <label>Confirm Password *</label>
                        <FormControl
                          sx={{ mt: 1, width: "100%" }}
                          variant="outlined"
                        >
                          <OutlinedInput
                            id="outlined-adornment-password"
                            type={showConfirmPassword ? "text" : "password"}
                            // value={password}
                            placeholder="********"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onFocus={validateFocus}
                            onInput={validateFocus}
                            error={!!errors.confirmpassword}
                            value={allUsers.confirmpassword}
                            name="confirmpassword"
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  className="eye-icon"
                                  aria-label={
                                    showConfirmPassword
                                      ? "hide the password"
                                      : "display the password"
                                  }
                                  onClick={handleClickConfirmShowPassword}
                                  edge="end"
                                >
                                  {showConfirmPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                        <span
                          style={{
                            color: "#d32f2f",
                            fontSize: 13,
                          }}
                        >
                          {errors.confirmpassword}
                        </span>{" "}
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Collapse>
            </Grid>
          </div>

          <Stack
            direction="row"
            spacing={2}
            sx={{ justifyContent: "center" }}
            className="edit-pop"
          >
            <div className="border-graient mt-10">
              <Button
                onClick={() => {
                  handlePopClose();
                  setErrors({});
                  setAllUsers({});
                  setExpandedMap(false);
                }}
              >
                Cancel
              </Button>
            </div>
            <div className="border-graient mt-10">
              {/* <Button onClick={()=>handleSubmit()}>Save</Button> */}
              {load ? (
                <Button>Processing...</Button>
              ) : (
                <Button
                  // onClick={() => {
                  //   navigate("/contact-list-table");
                  // }}
                  onClick={() => handleSubmit()}
                >
                  Save
                </Button>
              )}
            </div>
          </Stack>
        </Box>
      </Modal>
    </Box>
  );
}
